module.exports = __webpack_public_path__ + "img/East Timor.e5180d40.svg";